// extracted by mini-css-extract-plugin
export default {"button":"WishlistProductsListButton_button__e02oB"};